import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "asHeader_background"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { class: "asHeader_back" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "asHeader_col -name" }
const _hoisted_6 = { class: "asHeader_name" }
const _hoisted_7 = { class: "asHeader_city" }
const _hoisted_8 = {
  key: 2,
  class: "asHeader_col -nav"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_menu_modal = _resolveComponent("as-menu-modal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["asHeader", { '-blur': _ctx.background }])
  }, [
    (_ctx.background)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.background,
            alt: "",
            class: "asHeader_img"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.back)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "asHeader_col -back",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.subtitle), 1)
    ]),
    (_ctx.nav)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_as_menu_modal, { class: "asHeader_modal" }),
          _createVNode(_component_router_link, {
            to: '/user/setting',
            class: "asHeader_menu"
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}